import config from '../config';

/**
 * Build a public URL for a stored attachment path.
 * @param {string|null|undefined} path
 * @returns {string|null}
 */
export default function resolveAttachmentUrl(path) {
    if (!path) {
        return null;
    }
    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }

    let origin;
    try {
        origin = new URL(config.apiUrl).origin;
    } catch {
        origin = typeof window !== 'undefined' ? window.location.origin : '';
    }

    const trimmed = path.replace(/^\//, '');
    return `${origin}/storage/${encodeURI(trimmed)}`;
}
